import React from "react";

export function SupplierFormatter(cellContent, row){
    const supplierName = row.supplier && row.supplier[0] ? row.supplier[0].entityName : '-';
    
    return(
        <>
            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                {supplierName}
            </span>
        </>
    )
}
